<!--  -->
<template>
  <div class="index">
    <!-- <el-select @change="changeInsurer" v-model="insurerInfo.name" placeholder="请选择">
      <el-option
        v-for="item in insurerList"
        :key="item.id"
        :label="item.name"
        :value="item.name"
      >
      </el-option>
    </el-select>
    <div class="item">
      <div>险种名:</div>
      <div>{{insurerInfo.name}}</div>
    </div>
    <div class="item">
      <div>提醒:</div>
      <div>{{insurerInfo.notice_insurance}}</div>
    </div>
    <div class="item">
      <div>险种介绍:</div>
      <div>{{insurerInfo.product_details}}</div>
    </div>
    <el-button type="primary" style="width: 40%" @click="tohome"
      >确认选择</el-button
    > -->
    <div v-for="item in insurerList" :key="item.id" class="insurer-item">
      <div class="item">
        <div class="title">险种名:</div>
        <div class="name">{{ item.name }}</div>
      </div>
      <div class="item">
        <div class="title">提醒:</div>
        <div class="item-container">{{ item.notice_insurance }}</div>
      </div>
      <div class="item">
        <div class="title">险种介绍:</div>
        <div class="item-container">{{ item.product_details }}</div>
      </div>
      <div class="btn">
        <el-button type="primary" style="width: 40%" @click="tohome(item)"
          >进入</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { getInsurerListApi } from "@/api";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      insurerList: [],
      insurerInfo: {
        name: "",
        notice_insurance: "",
        product_details: "",
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    changeInsurer(e) {
      console.log(e);
      this.insurerList.forEach((item) => {
        if (item.name == e) {
          this.insurerInfo = JSON.parse(JSON.stringify(item));
        }
      });
    },
    getInsurerList() {
      getInsurerListApi().then((res) => {
        this.insurerList = res.data.data;
      });
    },
    tohome(item) {
        console.log(item);
      if (item.id==1) {
        // this.$store.commit("setinsurerInfo", this.insurerInfo);
        this.$router.push("/home"); //编程式导航
      }
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getInsurerList();
  },
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less">
.index {
  padding: 1rem;
  .insurer-item {
    padding: 1rem;
    border: 1px solid #ebeef5;
    box-shadow: 0px 0px 5px 1px #b6b6b6;
    margin-bottom: 3rem;
    .item {
      margin-top: 20px;
      .name {
        font-size: 2.5rem;
        text-align: center;
      }
      .item-container {
        text-indent: 2em;
      }
      .title {
        text-align: center;
        font-size: 1.8rem;
        min-width: 3rem;
        margin-bottom: 1rem;
      }
    }
    .btn {
        width: 100%;
        display: flex;
        justify-content: center;
      .el-button {
        margin: 1rem auto;
      }
    }
  }
}
</style>